<section class="container p-2">
	<div class="d-flex flex-wrap">
		<ng-container *ngIf="data">
			<div class="kp-card mx-auto text-center" style="min-width: 200px;" *ngFor="let interval of intervals">
				<div class="m-0">{{interval.base.title}}
					<i class="fa float-left" [class.fa-angle-up]="showAll" [class.fa-angle-down]="!showAll"
						(click)="showAll=!showAll"></i>
				</div>
				<div class="border-top" *ngFor="let action of actions" [class.d-none]="!showAll && action.visible==false">
					<div class="d-flex justify-content-between">
						<span>{{action.title}}</span>
						<span *ngIf="action.conversion" class="mr-2">{{_conversion(interval.base,action)|percent}}</span>
					</div>
					<div class="h6 m-0" [title]="_data_tooltip(interval.base,action)">
						{{_data(interval.base,action) | number}}
					</div>
					<div class="d-flex justify-content-between">
						<div [title]="_data_tooltip(interval.compare,action)">
							{{_data(interval.compare,action) | number}}
						</div>
						<div [class.f-green]="_diff(interval,action) > 0" [class.f-red]="_diff(interval,action) < 0">
							<span dir="ltr"> {{_diff(interval,action)/_data(interval.compare,action)|percent}}</span>
							<i class="fa " [class.fa-arrow-up]="_diff(interval,action) > 0"
								[class.fa-arrow-down]="_diff(interval,action) < 0"></i>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

		<div class="kp-card mx-auto text-center" style="min-width: 200px;" *ngIf="pendingActivities && pendingSummary">
			<div class="m-0">7 روز گذشته</div>
			<div class="border-top">
				<h6>آگهی</h6>
				<div class="d-flex justify-content-between">
					<span>پیشتاز</span>
					<span>{{pendingSummary.paidPendingJobs|number}}</span>
				</div>
				<div class="d-flex justify-content-between">
					<span>پرداخت نشده</span>
					<span>{{pendingSummary.notPaidPendingJobs|number}}</span>
				</div>
				<div class="text-left">
					<div class="p-1 pointer" (click)="pendingSummary._jobs=!pendingSummary._jobs">
						<i class="fa fa-angle-down"></i>
					</div>
				</div>
				<div *ngIf="pendingSummary._jobs">
					<div *ngFor="let t of ['paid', 'free']">
						<h6>{{t=='paid' ? 'پیشتاز': 'عادی'}}</h6>
						<div class="d-flex flex-wrap justify-content-between" *ngFor="let item of pendingActivities.jobStats[t]">
							<span>{{item.Key|readable:'jobStatus'}}</span>
							<span>{{item.DocCount|number}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="border-top">
				<h6>کارجو</h6>
				<div class="d-flex justify-content-between">
					<span>در انتظار تایید</span>
					<span>{{pendingSummary.warmLeads|number}}</span>
				</div>
				<div class="d-flex justify-content-between">
					<span>در انتظار تکمیل</span>
					<span>{{pendingSummary.lukeWarmLeads|number}}</span>
				</div>
				<div class="text-left">
					<div class="p-1 pointer" (click)="pendingSummary._leads=!pendingSummary._leads">
						<i class="fa fa-angle-down"></i>
					</div>
				</div>
				<div *ngIf="pendingSummary._leads">
					<div class="d-flex flex-wrap justify-content-between"
						*ngFor="let item of pendingActivities.seekerLeadStats|keyvalue">
						<span>{{item.key|readable:'recruitLeadStatus'}}</span>
						<span>{{item.value|number}}</span>
					</div>
				</div>
			</div>
			<div class="border-top pointer">
				<h6>وظایف</h6>
				<h6 class="mb-0">{{pendingSummary.tasks|number}}</h6>
				<div class="text-left">
					<div class="p-1 pointer" (click)="pendingSummary._tasks=!pendingSummary._tasks">
						<i class="fa fa-angle-down"></i>
					</div>
				</div>
				<div *ngIf="pendingSummary._tasks">
					<div class="d-flex flex-wrap justify-content-between"
						*ngFor="let item of pendingActivities.overdueTasksStats">
						<span>{{item.Operator}}</span>
						<span>{{item.DocCount|number}}</span>
					</div>
				</div>
			</div>

		</div>
	</div>

	<div class="d-flex justify-content-between align-items-center">
		<app-date-range sranges="today,yesterday,last7days,last30days,last90days,last180days,last365days"
			default-range="last30days" [(start)]="reportFrom" [(end)]="reportTo"></app-date-range>

		<div class="mx-2">
			<select [(ngModel)]="interval">
				<option value="Hour">ساعتی</option>
				<option value="Day">روزانه</option>
				<option value="Week">هفتگی</option>
				<option value="Month">ماهانه</option>
				<option value="Year">سالانه</option>
			</select>
		</div>

		<button (click)="getTimeReport()">دریافت</button>

	</div>
</section>

<div class="col-12" style="height:500px;">
	<highcharts-chart style="width: 100%!important;display: block;height: 100%;" *ngIf="options" [Highcharts]="Highcharts"
		[options]="options">
	</highcharts-chart>
</div>